<template>
  <div>
    <p>
      The database can contain two types of data :
      <ul>
      <li><b>Real data :</b> Real data imported by a user.</li>
      <li><b>Generated data :</b> Data added to the database from a data generation mission.</li>
    </ul>
    In the latter case, the user can filter the data to be analysed by data generation mission too.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipDataTypeSelection'
}
</script>